module.exports = __webpack_public_path__ + "static/img/function-title.d955fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/function-title.png
// module id = xFRP
// module chunks = 0